<mat-card *ngIf="exerciceRow"
          class="exercice-card"
          appearance="outlined"
          [ngStyle]="{ 'display': isEditOpened || isVideoOpened ? 'none' : 'block' }"
>
  <mat-card-header class="mat-header">
    <img *ngIf="exerciceRow.exercice?.image || exerciceRow.exercice?.video_thumbnail_path" [alt]="exerciceRow.exercice.name"
         ngSrc="{{ conf.storageRootUrl + (exerciceRow.exercice.image || exerciceRow.exercice.video_thumbnail_path) }}" fill>
    <div class="video-overlay" *ngIf="exerciceRow.exercice.video_path">
      <mat-icon class="play-icon" (click)="onPlayVideo()">play_circle_filled</mat-icon>
    </div>
    <mat-icon *ngIf="!(exerciceRow.exercice?.image || exerciceRow.exercice?.video_thumbnail_path)" >
      image
    </mat-icon>
  </mat-card-header>
  <mat-card-content class="card-content">
    <mat-card-title>
      <div class="title-container">
        {{ exerciceRow.exercice.name }}
        <app-chat-share [organization]="organization" [sharable]="getAsSharableType(exerciceRow.exercice)">
          <button mat-icon-button matTooltip="{{ 'Share' | translate }}">
            <mat-icon>share</mat-icon>
          </button>
        </app-chat-share>
      </div>
    </mat-card-title>
    <mat-card-subtitle>
      <div class="accents-container">
        <div *ngFor="let category of exerciceRow.categories">
          <exercice-category-thumbnail *ngIf="category" [hideText]="true" [data]="category" />
          {{ category?.name }}
        </div>
      </div>
    </mat-card-subtitle>
    <div class="tags-container">
      {{ exerciceRow.exercice.tags }}
    </div>
    <div class="description-container">
      {{ exerciceRow.exercice.description }}
    </div>
    <div class="separator"></div>

    <session-exercice-duration class="session-exercice-component" *ngIf="exerciceRow.exercice?.exerciceType === Exercice.TYPE_DURATION"
                               [data]="getEmptyItemExercice()"
                               [organization]="organization"
                               [isEditable]="false"
                               [basicDisplay]="true" >
    </session-exercice-duration>
    <session-exercice-repeat class="session-exercice-component" *ngIf="exerciceRow.exercice.exerciceType === Exercice.TYPE_REPEAT"
                             [data]="getEmptyItemExercice()"
                             [organization]="organization"
                             [isEditable]="false"
                             [basicDisplay]="true" >
    </session-exercice-repeat>

  </mat-card-content>
  <mat-dialog-actions class="action-buttons">
    <button *ngIf="exerciceRow && exerciceRow.rights?.edit"
            mat-raised-button color="flat" (click)="onModifyExerciceClicked()">{{ 'Modify' | translate }}</button>
    <button mat-raised-button mat-dialog-close color="accent">{{ 'Close' | translate }}</button>
  </mat-dialog-actions>
</mat-card>
